import Vue from 'vue'
import gql from 'graphql-tag'
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { ApolloResponse } from '@/interfaces/apollo'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { AccountContact } from '@/modules/AccountContactRelation/interfaces/account-contact'
import { showErrors } from '@/utils/snack'
import { dateTimeToDisplay } from '@/utils/dateTime'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppSearch from '@/components/AppSearch.vue'
import AppRefresh from '@/components/AppRefresh.vue'
import AppTabs from '@/components/AppTabs.vue'
import {
  relationRoles
} from '@/modules/AccountContactRelation/helpers/account-contact'
import { getAccountContact } from '@/modules/AccountContactRelation/gql/account-contact.gql'
import RelationDialog from '@/modules/AccountContactRelation/scripts/account-contact-relation-dialog'
import AccountContactRelationDetail from '@/modules/AccountContactRelation/views/detail.vue'

@Component({
  components: {
    AppBreadcrumbs,
    AppSearch,
    AppRefresh,
    AppTabs,
    AccountContactRelationDetail
  }
})
export default class AccountContactRelation extends mixins(RelationDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Accounts',
      to: { name: 'AccountsList' }
    }
  ]

  relationName = ''

  relation: AccountContact | null = null

  windowSize = {
    w: 0,
    h: 0,
    cW: 0
  }

  tabActive = 0
  tabItems = [
    { title: 'Details', route: 'AccountContactRelationDetail' },
    { title: 'Related', route: '' }
  ]

  relationRoles = relationRoles

  dateTimeToDisplay = dateTimeToDisplay

  get tabTitles () {
    return this.tabItems.map(item => item.title)
  }

  get acctRoute () {
    const { account } = this.relation as AccountContact
    return {
      name: 'AccountDetailDetail',
      params: {
        id: account.id
      }
    }
  }

  get contRoute () {
    const { contact } = this.relation as AccountContact
    return {
      name: 'ContactDetailDetail',
      params: {
        id: contact.id
      }
    }
  }

  mounted () {
    const { name } = this.$route
    const index = this.$R.findIndex((item: any) => item.route === name)(this.tabItems)
    this.tabActive = index
    this.onResize()
    this.getAccountContact()
  }

  onResize () {
    const container = this.$refs.container as Vue & { clientWidth: number }
    this.windowSize = { w: window.innerWidth, h: window.innerHeight, cW: container.clientWidth }
  }

  clickTabHandler (index: number) {
    const item = this.tabItems[index]
    if (item.route) {
      this.$router.push({
        name: item.route
      })
    }
  }

  async getAccountContact () {
    const accountContactId = Number(this.$route.params.id)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getAccountContact,
        variables: {
          accountContactId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.relation = result.data.getAccountContact as AccountContact

      this.breadcrumbs.push({
        text: this.relation.account.name,
        to: {
          name: 'AccountDetailDetail',
          params: {
            id: this.relation.account.id
          }
        }
      })
      this.breadcrumbs.push({
        text: 'View Relationship'
      })
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async deleteRelationConfirm () {
    const { account } = this.relation as AccountContact
    await this.deleteRelationPost()
    this.$router.replace({
      name: 'AccountDetailDetail',
      params: {
        id: account.id + ''
      }
    })
  }
}
